import InstallationListPage from './InstallationListPage';

export default InstallationListPage;
